import { ReactComponent as NotificationSvg } from "../../assets/images/svgs/notification.svg";

const NotificationIcon = ({ className = "", ...props }) => {
  return (
    <NotificationSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default NotificationIcon;
